import { render } from "./CrossStep3Completato.vue?vue&type=template&id=3efa8808"
import script from "./CrossStep3Completato.vue?vue&type=script&lang=js"
export * from "./CrossStep3Completato.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__